module.exports = __webpack_public_path__ + "img/Weapon_281.6fa84ede.png";